import { getFirstErrorCode, isAxiosError } from './error';

export function getApiErrorFingerprint(error: unknown): string[] | undefined {
  if (!isAxiosError(error)) {
    return undefined;
  }
  const endpoint = error.config?.noddiEndpoint;
  const method = error.config?.method;
  const status = error.status ?? error.response?.status;
  if (!endpoint || !method || status === undefined) {
    return undefined;
  }

  // Resource keys exclude IDs/query params and cover opaque booking codes too.
  // Omit {{ default }}: shared Axios/logger stacks otherwise merge unrelated
  // endpoints, while changing build stacks can split the same API failure.
  return ['noddi-api', method.toUpperCase(), endpoint, String(status), getFirstErrorCode(error) ?? 'unknown'];
}
